import { useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const styles = makeStyles(() => ({
	IconContainer: {
		position: 'absolute',
		right: 0,
		top: 10,
		bottom: 0,
		display: 'flex',
	},
}));

export default styles;
